(function () {
  class RisingBubbles extends PIXI.Container {
    constructor() {
      super();
      this._completeCallback;
      StateMachine.Create(this);

      this._emitter = undefined;
      this._lifetime = 0;
      this._clear = false;
      this._loaded = false;
    }

    initialise() {
      const self = this;
      Reflex.registerEventHandler("orientationChange", this.orientationChange.bind(this));
    }

    startBubbles() {
      this._emitter.particleEmitter.emit = true;
    }

    stopBubbles() {
      this._emitter.particleEmitter.emit = false;
    }

    setup(emitter = "bubbles_emitter") {
      this._emitter = particleManager.createEmitter(emitter, this, 0, 0, false);
      this._emitter.particleEmitter.emit = false;
      this._lifetime = this._emitter.particleEmitter.maxLifetime;
      this._emitter.x = 0;
      this._loaded = true;
      this.orientationChange();
    }

    orientationChange() {
      if (!this._loaded) {
        return;
      }

      if (this._clear) {
        this._emitter.particleEmitter.cleanup();
      }

      this._emitter.y = systemData.isLandscape ? 720 : 1280;

      const lifetime = systemData.isLandscape ? this._lifetime : this._lifetime * 3.7;

      this._emitter.particleEmitter.minLifetime = lifetime;
      this._emitter.particleEmitter.maxLifetime = lifetime;
    }
  }

  create = function (json) {
    return new RisingBubbles();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType("risingBubbles", create, initialise, getFilesRequired);
})();
